import React, { useContext, useEffect, Suspense, lazy } from 'react';
import Login from './screens/Auth/Login';
import VendorLogin from './screens/VendorLogin';
import ForgetPassword from './screens/Auth/ForgetPassword';
import { makeStyles } from '@material-ui/core/styles';
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import CustomizedTabs from './components/Tabs';
import { mainRoutes } from './config/routes';
import BreadcrumbBar from './components/BreadcrumbBar';
import { BreadcrumbTrailProvider } from './context/BreadcrumbTrailContext';
// eslint-disable-next-line
import { Grid, Container, Card, CardContent, } from '@material-ui/core';
import Background from "./assets/images/background.jpg";
import SwipeableTextMobileStepper from './components/Stepper';
import useToken from './hooks/useToken';
import Home from './screens/admin/Users/Home/home';
import Landing from './screens/admin/Users/Home/landing';

import { AuthContext } from './context/auth-context';
// eslint-disable-next-line
import { routes, roleBasedRoutes } from './constants/roles';

import CustomAppBar from './components/AppBar';
import Loading from './components/Loading';
import ContractReports from './screens/admin/PurchaseOrders/ContractReports';
import SoftScheduling from './screens/admin/SoftScheduling';
import Certification from './screens/admin/certification';
import EditCertification from './screens/admin/certification/EditCertification';
import CreateCertification from './screens/admin/certification/CreateCertification';
import ViewCertification from './screens/admin/certification/ViewCertification';
import AuditReports from './screens/admin/AuditReports';
import QLIReports from './screens/admin/QLI';
import Authenticator from './screens/Auth/Authenticator';
import { AutoLogoutProvider } from './AutoLogoutContext';
// import jwtDecode from 'jwt-decode';



const SoftSchedulingDetails = lazy(() => import('./screens/admin/SoftScheduling/SoftSchedulingDetails'));
const EditBilling = lazy(() => import('./screens/admin/Contacts/EditBilling'));
const EditShipping = lazy(() => import('./screens/admin/Contacts/EditShipping'));
const Leads = lazy(() => import('./screens/admin/Leads'));
const Accounts = lazy(() => import('./screens/admin/Accounts'));
const SampleInformation = lazy(() => import('./screens/admin/SampleInformation'));
const ViewAccount = lazy(() => import('./screens/admin/Accounts/AccountDetails'));
const EditAccount = lazy(() => import('./screens/admin/Accounts/EditAccount'));
const CreateContact = lazy(() => import('./screens/admin/Contacts/CreateContact'))
const CreateSampleRequestAccount = lazy(() => import('./screens/admin/Sample Requests/CreateSample'))
const CreateQuoteFromAccount = lazy(() => import('./screens/admin/Quotes/CreateQuote'));
const Contacts = lazy(() => import('./screens/admin/Contacts/index'));
const ViewContact = lazy(() => import('./screens/admin/Contacts/ContactDetails'))
const EditContact = lazy(() => import('./screens/admin/Contacts/EditContact'));
const AddBillingAddress = lazy(() => import('./screens/admin/Contacts/AddBilling'));
const AddShippingAddress = lazy(() => import('./screens/admin/Contacts/AddShipping'));
const ViewBillingAddress = lazy(() => import('./screens/admin/Contacts/ViewBilling'));
const ViewShippingAddress = lazy(() => import('./screens/admin/Contacts/ViewShipping'))
const SampleRequests = lazy(() => import('./screens/admin/Sample Requests'));
const PurchaseOrders = lazy(() => import('./screens/admin/PurchaseOrders'));
const CreatePurchaseOrder = lazy(() => import('./screens/admin/PurchaseOrders/CreatePurchaseOrder'));
const PurchaseOrderDetails = lazy(() => import('./screens/admin/PurchaseOrders/PurchaseOrderDetails'));
const EditPurchaseOrder = lazy(() => import('./screens/admin/PurchaseOrders/EditPurchaseOrder'));
const CreateLead = lazy(() => import('./screens/admin/Leads/CreateLead'));
const EditLead = lazy(() => import('./screens/admin/Leads/EditLead'));
const VendorPurchaseForm = lazy(() => import('./screens/admin/DispatchNew/Create'));
const Settings = lazy(() => import('./screens/admin/Settings'));
const PackingType = lazy(() => import('./screens/admin/PackingTypeNew'));
const CreatePackingType = lazy(() => import('./screens/admin/PackingTypeNew/CreateEdit'));
const EditPackingType = lazy(() => import('./screens/admin/PackingTypeNew/CreateEdit'));
const PackingTypeDetails = lazy(() => import('./screens/admin/PackingTypeNew/View'));
const Users = lazy(() => import('./screens/admin/Users'));
const PowerBIAdmin = lazy(() => import('./screens/admin/PowerBI'));
const ViewPowerBiReport = lazy(() => import('./screens/admin/PowerBI/view'));
const ShowPowerBiReport = lazy(() => import('./screens/admin/PowerBI/ReportEmbed'));
const CreateEditPowerBiReport = lazy(() => import('./screens/admin/PowerBI/CreateEdit'));
const Supplier = lazy(() => import('./screens/admin/Supplier'));
const EditSupplier = lazy(() => import('./screens/admin/Supplier/CreateEdit'));
const CreateSupplier = lazy(() => import('./screens/admin/Supplier/CreateEdit'));
const SupplierDetails = lazy(() => import('./screens/admin/Supplier/View'));
const MRIN = lazy(() => import('./screens/admin/Mrin'));
const MRINDetails = lazy(() => import('./screens/admin/Mrin/view'));
const MRINCreateEdit = lazy(() => import('./screens/admin/Mrin/CreateEdit'));
const GC = lazy(() => import('./screens/admin/GreenCoffee'));
const CreateGC = lazy(() => import('./screens/admin/GreenCoffee/CreateEdit'));
const EditGC = lazy(() => import('./screens/admin/GreenCoffee/CreateEdit'));
const GcDetails = lazy(() => import('./screens/admin/GreenCoffee/View')); 
const GcRequired = lazy(() => import('./screens/admin/GcRequired'));

const Gcdailyrates = lazy(() => import('./screens/admin/Gcdailyrates'));
const CreateGcdailyrates = lazy(() => import('./screens/admin/Gcdailyrates/CreateGcdailyrates'));
const EditGcdailyrates = lazy(() => import('./screens/admin/Gcdailyrates/EditGcdailyrates'));
const ViewGcdailyrates = lazy(() => import('./screens/admin/Gcdailyrates/ViewGcdailyrates'));

const Gcenquiry = lazy(() => import('./screens/admin/Gcenquiry'));
const CreateGcenquiry = lazy(() => import('./screens/admin/Gcenquiry/CreateGcenquiry'));
const EditGcenquiry = lazy(() => import('./screens/admin/Gcenquiry/EditGcenquiry'));
const ViewGcenquiry = lazy(() => import('./screens/admin/Gcenquiry/ViewGcenquiry'));

const Allocation = lazy(() => import('./screens/admin/Allocation'));
const CreateAllocation = lazy(() => import('./screens/admin/Allocation/CreateAllocation'));
const EditAllocation = lazy(() => import('./screens/admin/Allocation/EditAllocation'));
const AllocationDetails = lazy(() => import('./screens/admin/Allocation/AllocationDetails'));
const Quotes = lazy(() => import('./screens/admin/Quotes'));
const CreateQuote = lazy(() => import('./screens/admin/Quotes/CreateQuote'));
const CreateQuoteItem = lazy(() => import('./screens/admin/Quotes/CreateQuoteItem'));
const ViewQuoteItem = lazy(() => import('./screens/admin/Quotes/QuoteItemDetails'));
const ViewPendingQuoteItem = lazy(() => import('./screens/admin/Quotes/QuoteItemDetails'));
const EditQuoteItem = lazy(() => import('./screens/admin/Quotes/EditQuoteItem'));
const EditQuote = lazy(() => import('./screens/admin/Quotes/EditQuote'));
const ViewQuote = lazy(() => import('./screens/admin/Quotes/QuoteDetailsByRole'));

const Quotation = lazy(() => import('./screens/admin/Quotation'));
 const CreateQuotation = lazy(() => import('./screens/admin/Quotation/CreateQuotation'));
const CreateQuotationItem = lazy(() => import('./screens/admin/Quotation/CreateQuotationItem'));
 const ViewQuotationItem = lazy(() => import('./screens/admin/Quotation/QuotationItemDetails'));
   const ViewPendingQuotationItem = lazy(() => import('./screens/admin/Quotation/QuotationItemDetails'));
const EditQuotationItem = lazy(() => import('./screens/admin/Quotation/EditQuotationItem'));
const EditQuotation = lazy(() => import('./screens/admin/Quotation/EditQuotation'));
 const ViewQuotation = lazy(() => import('./screens/admin/Quotation/QuoteDetailsByRole'));



const Order = lazy(() => import('./screens/admin/Order'));
const OrderDetails = lazy(() => import('./screens/admin/Order/OrderDetails'));
const CreateOrder = lazy(() => import('./screens/admin/Order/CreateOrder'));
const OrderLineItemList = lazy(() => import('./screens/admin/OrderLineItem'));
const OrderLineItemDetails = lazy(() => import('./screens/admin/Order/OrderLineItemDetails'));
const OrderDispatchDetails = lazy(() => import('./screens/admin/Order/OrderDispatchDetails'));
const OrderDispatchList = lazy(() => import('./screens/admin/Order/OrderDispatchList'));
const DebitNoteGC = lazy(() => import('./screens/admin/DebitNoteGc'));
const Packaging = lazy(() => import('./screens/admin/Packaging'));
const PackagingDetails = lazy(() => import('./screens/admin/Packaging/PackagingDetails'))
const CreateUser = lazy(() => import('./screens/admin/Users/CreateEdit'));
const UserDetails = lazy(() => import('./screens/admin/Users/view'));
const EditUser = lazy(() => import('./screens/admin/Users/CreateEdit'));
// const CreateDebitNote = lazy(() => import('./screens/admin/DebitNoteGc/AddDebitNoteGc'));
const CreateEditDebitNoteGC = lazy(() => import('./screens/admin/DebitNoteGc/CreateEdit'));
const CreateSettings = lazy(() => import('./screens/admin/Settings/taxMaster/CreateTax'));
const ViewSettings = lazy(() => import('./screens/admin/Settings/taxMaster/TaxDetails'));
const EditSettings = lazy(() => import('./screens/admin/Settings/taxMaster/EditTax'));
// const EditDebitNote = lazy(() => import('./screens/admin/DebitNoteGc/EditDebitNoteGc'));
// const ViewDebitNote = lazy(() => import('./screens/admin/DebitNoteGc/DebitNoteGcDetails'));
const DebitNoteView = lazy(() => import('./screens/admin/DebitNoteGc/DebitNoteView'));
const CreateSampleRequest = lazy(() => import('./screens/admin/Sample Requests/AddSample'));
const ViewSampleRequest = lazy(() => import('./screens/admin/Sample Requests/SampleDetails'));
const EditSampleRequest = lazy(() => import('./screens/admin/Sample Requests/EditSample'));
const ViewDispatch = lazy(() => import('./screens/admin/PurchaseOrders/Dispatch/DispatchView'));
const AddSampleItem = lazy(() => import('./screens/admin/Sample Requests/AddSampleItem'));
const ViewSampleItem = lazy(() => import('./screens/admin/Sample Requests/ViewSampleItem'));
const EditSampleItem = lazy(() => import('./screens/admin/Sample Requests/EditSampleItem'));
//Master Sample
const MasterSamples = lazy(() => import('./screens/admin/MasterSample'));
const ViewMasterSample = lazy(() => import("./screens/admin/MasterSample/MasterSampleView"));
const CreateEditMasterSample = lazy(() => import("./screens/admin/MasterSample/CreateEdit"));

//Alternative Sample
const AlternativeSamples = lazy(() => import('./screens/admin/AlternativeSample'));
const ViewAlternativeSample = lazy(() => import("./screens/admin/AlternativeSample/view"));
const CreateEditAlternativeSample = lazy(() => import("./screens/admin/AlternativeSample/createEdit"));
//Customer Sample
const CustomerSamples = lazy(() => import('./screens/admin/CustomerSample'));
const ViewCustomerSample = lazy(() => import("./screens/admin/CustomerSample/view"));
const CreateEditCustomerSample = lazy(() => import("./screens/admin/CustomerSample/CreateEdit"));
//Blend Sheet
const BlendSheet = lazy(() => import('./screens/admin/BlendSheet'));
const ViewBlendSheet = lazy(() => import("./screens/admin/BlendSheet/view"));
const BlendSheetCreateEdit = lazy(() => import("./screens/admin/BlendSheet/CreateEdit"));
//DispatchNew
const DispatchNew = lazy(() => import('./screens/admin/DispatchNew'));
const ViewDispatchNew = lazy(() => import("./screens/admin/DispatchNew/view"));
// const EditDispatchNew = lazy(() => import("./screens/admin/DispatchNew/EditDispatchNew"));

// Batch Outputs
const BatchOutputs = lazy(() => import('./screens/admin/BatchOutput'));
const CreateBatchOutput = lazy(() => import("./screens/admin/BatchOutput/CreateEdit"));
const BatchOutputsDetails = lazy(() => import("./screens/admin/BatchOutput/view"));
const EditBatchOutput = lazy(() => import("./screens/admin/BatchOutput/CreateEdit"));
const ForecastCapacity = lazy(() => import('./screens/admin/ForecastCapacity'));
const CreateEditForecastCapacity = lazy(() => import('./screens/admin/ForecastCapacity/CreateEdit'));
const ForecastCapacityView = lazy(() => import('./screens/admin/ForecastCapacity/view'));

// Finished goods validity
const FGvalidity = lazy(() => import('./screens/admin/FGValidity'));
const CreateEditFGvalidity = lazy(() => import('./screens/admin/FGValidity/CreateEdit'));
const FGvalidityDetails = lazy(() => import('./screens/admin/FGValidity/view'));

// Production Schedule
const ProductionSchedule = lazy(() => import('./screens/admin/ProductionSchedule'));
const CreateEditProductionSchedule = lazy(() => import('./screens/admin/ProductionSchedule/CreateEdit'));
const ProductionScheduleDetails = lazy(() => import('./screens/admin/ProductionSchedule/view'));
const ProductionScheduleCalendarBlocking = lazy(() => import('./screens/admin/ProductionSchedule/CalendarBlockingPage'));

// Production Shipment Sample
const PreShipmentSample = lazy(() => import('./screens/admin/PSS'));
const CreateEditPreShipmentSample = lazy(() => import('./screens/admin/PSS/CreateEdit'));
const PreShipmentSampleDetails = lazy(() => import('./screens/admin/PSS/view'));
const EditPreShipmentLineItem = lazy(() => import('./screens/admin/PSS/EditLineItem'));

// Finance costing
const Finance = lazy(() => import('./screens/admin/Finance'));
const CreateEditFinanceCosting = lazy(() => import('./screens/admin/Finance/CreateEdit'));
const FinanceCostingDetails = lazy(() => import('./screens/admin/Finance/View'));

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100vw',
    position: 'relative',
    maxWidth: '100%',
    margin: 0,
    backgroundImage: `url(${Background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingRight: 0,
    paddingLeft: 0
  },
}));

const WithBackground = (props) => {
  const classes = useStyles();
  return (
    <Container component="main" maxWidth="xs" className={classes.root}>
      {
        !props.iframe ?
          <Grid container spacing={0} direction="column" alignItems="center" justify="center"
            style={{ minHeight: '100vh' }}>
            <Grid item xs={12} sm={12}>
              <Card>
                <CardContent>
                  {props.children}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          :
          <Grid container spacing={0} direction="row" style={{ height: '100vh' }}>
            <Grid item xs={12} sm={6} justify="center" alignItems="center" style={{ display: 'flex' }}>
              <Card>
                <CardContent>
                  {props.children}
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <SwipeableTextMobileStepper />
            </Grid>
          </Grid>

      }
    </Container>
  )
}


function RequireAuth(props) {
  let auth = useContext(AuthContext);
  let location = useLocation();
  // Use localStorage as a fallback to handle the race condition where storeToken has already
  // written to localStorage synchronously but React state (auth.token / auth.role) hasn't
  // updated yet when navigate() fires after a successful OTP verification.
  const token = auth.token || localStorage.getItem("currentUserId");
  const role  = auth.role  || localStorage.getItem("currentUserroledecode");
  const pathIndex = roleBasedRoutes?.[role]?.findIndex(path => path === props.path);
  if (!token) {
    return <Navigate to={routes.login} state={{ from: location }} />;
  }
  else if (pathIndex === -1) {
    return <Navigate to={roleBasedRoutes[role]?.[0]} />
  }
  else return props.children
}
function CheckAuthenticator(props){
  let auth = useContext(AuthContext);
  const location = useLocation();
  const pathIndex = roleBasedRoutes?.[auth.role]?.findIndex(path => path === location?.state?.from?.pathname);
  if(auth?.token){

    return <Navigate to={location?.state?.from?.pathname || "/home"} />
  }
  return props.children;
  // else{
  //   return <Navigate to={routes.login} state={{ from: location }} />;
  // }
}
function CheckAuth(props) {
  let auth = useContext(AuthContext);
  const location = useLocation();
  const pathIndex = roleBasedRoutes?.[auth.role]?.findIndex(path => path === location?.state?.from?.pathname);
   if (!!auth.token && pathIndex > -1) {
    return <Navigate to={location?.state?.from?.pathname || "/home"} />

  }
  else if (!!auth.token) {
    return <Navigate to={roleBasedRoutes[auth.role]?.[0]} />;
  }
  return props.children;
}
function AuthWrapperWithTab(props) {
  const location = useLocation();
  if(localStorage?.getItem('CurrentActiveTab')){
    var checkRoute = localStorage?.getItem('CurrentActiveTab')?.split('/')?.[1] || '';
    var newCheckRoute = location.pathname?.split('/')?.[1] || '';
    if(checkRoute !== newCheckRoute) {
      localStorage.setItem('RowsPerPage', 25);
    }
  }

  localStorage.setItem('CurrentActiveTab', location.pathname);
  return <RequireAuth path={props.path}>
    <CustomAppBar>
      <CustomizedTabs routes={mainRoutes}>
        {props.path !== routes.home && <BreadcrumbBar />}
        <Suspense fallback={<Loading />}>
          {props.children}
        </Suspense>
      </CustomizedTabs>
    </CustomAppBar>
  </RequireAuth>
}

function App() {
  const { storeToken, setPreference, getPreference, token, role, removeToken, refreshToken, company, updateCompany } = useToken();

  useEffect(() => {   
    const refreshInterval = setInterval(() => {
      refreshToken();      
    }, 3.6e+6)
    return () => {
      clearInterval(refreshInterval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function checkRouteRedirection(routepath) {
    const roll = localStorage.getItem("currentUserRole");
    const checkRoutess = roleBasedRoutes[roll]?.includes(routepath);
    return checkRoutess === true ? routepath: routes.home
    // return routepath;
  }

  return (
    <>
      <AuthContext.Provider
        value={{
          token: token,
          role: role,
          company: company,
          storeToken: storeToken,
          setPreference: setPreference,
          getPreference: getPreference,
          removeToken: removeToken,
          updateCompany: updateCompany,
        }}
      >
        
          <AutoLogoutProvider>
          <BreadcrumbTrailProvider>
            <Routes key={company}>
              <Route path="/404" handler={<Home />} />

              {/* <Route path={routes.vendor} element={<RequireAuth path={routes.vendor}>
                <CustomizedTabs routes={vendorRoutes}>
                  <VendorPurchaseForm />
                </CustomizedTabs>
              </RequireAuth>}
              /> */}

              <Route
                path={routes.home}
                exact
                element={
                  <AuthWrapperWithTab path={routes.home}>
                    <Landing />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={routes.dashboard}
                exact
                element={
                  <AuthWrapperWithTab path={routes.dashboard}>
                    <Home />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.leads)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.leads}>
                    <Leads />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.contractReports)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.contractReports}>
                    <ContractReports />
                  </AuthWrapperWithTab>
                }
              />
              {/* <Route path={routes.createLead} exact element={  */}

              <Route
                path={checkRouteRedirection(routes.createLead)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createLead}>
                    <CreateLead />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editLead)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editLead}>
                    <EditLead />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewLead)}
                element={
                  <AuthWrapperWithTab path={routes.viewLead}>
                    <EditLead />
                  </AuthWrapperWithTab>
                }
              />
              {/* <Route path={routes.samples} exact element={
              <AuthWrapperWithTab>
                <Samples />
              </AuthWrapperWithTab>} /> */}
              <Route
                path={checkRouteRedirection(routes.packaging)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.packaging}>
                    <Packaging />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewPackaging)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewPackaging}>
                    <PackagingDetails />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.accounts)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.accounts}>
                    <Accounts />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewAccount)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewAccount}>
                    <ViewAccount />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editAccount)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editAccount}>
                    <EditAccount />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createContact}>
                    <CreateContact />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(
                  routes.createSampleRequestFromAccount
                )}
                exact
                element={
                  <AuthWrapperWithTab
                    path={routes.createSampleRequestFromAccount}
                  >
                    <CreateSampleRequestAccount />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createQuoteFromAccount)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createQuoteFromAccount}>
                    <CreateQuoteFromAccount />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.contacts)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.contacts}>
                    <Contacts />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewContact}>
                    <ViewContact />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editContact}>
                    <EditContact />
                  </AuthWrapperWithTab>
                }
              />
              {/* certification */}
              <Route
                path={checkRouteRedirection(routes.certification)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.certification}>
                    <Certification />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.auditreports)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.auditreports}>
                    <AuditReports />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.qlireports)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.qlireports}>
                    <QLIReports />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editcertification)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editcertification}>
                    <EditCertification />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createcertification)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createcertification}>
                    <CreateCertification />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewcertification)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewcertification}>
                    <ViewCertification />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.addBillingAddressOnContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.addBillingAddressOnContact}>
                    <AddBillingAddress />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.addShippingAddressOnContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.addShippingAddressOnContact}>
                    <AddShippingAddress />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewBillingOnContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewBillingOnContact}>
                    <ViewBillingAddress />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewShippingOnContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewShippingOnContact}>
                    <ViewShippingAddress />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewBillingAddressOnContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewBillingAddressOnContact}>
                    <EditBilling />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewshippingAddressOnContact)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewshippingAddressOnContact}>
                    <EditShipping />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.sampleRequest)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.sampleRequest}>
                    <SampleRequests />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createSampleRequest)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createSampleRequest}>
                    <CreateSampleRequest />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewSampleRequest)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewSampleRequest}>
                    <ViewSampleRequest />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editSampleRequest)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editSampleRequest}>
                    <EditSampleRequest />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.addSampleItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.addSampleItem}>
                    <AddSampleItem />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewSampleItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewSampleItem}>
                    <ViewSampleItem />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editSampleItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editSampleItem}>
                    <EditSampleItem />
                  </AuthWrapperWithTab>
                }
              />
              {/* <Route path="/master-sample-request" exact element={
              <AuthWrapperWithTab>
                <MasterSampleRequests />
              </AuthWrapperWithTab>} />             */}
              <Route
                path={checkRouteRedirection(routes.quote)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.quote}>
                    <Quotes />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.dispatchinfo)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.dispatchinfo}>
                    <DispatchNew />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewQuote)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewQuote}>
                    <ViewQuote />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createQuote)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createQuote}>
                    <CreateQuote />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editQuote)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editQuote}>
                    <EditQuote />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createQuoteItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createQuoteItem}>
                    <CreateQuoteItem />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewQuoteItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewQuoteItem}>
                    <ViewQuoteItem />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewPendingQuoteItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewPendingQuoteItem}>
                    <ViewPendingQuoteItem />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editQuoteItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editQuoteItem}>
                    <EditQuoteItem />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.quotation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.quotation}>
                    <Quotation />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.viewQuotation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewQuotation}>
                    <ViewQuotation />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createQuotation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createQuotation}>
                    <CreateQuotation />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createQuotationItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createQuotationItem}>
                    <CreateQuotationItem />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewQuotationItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewQuotationItem}>
                    <ViewQuotationItem />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.editQuotation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editQuotation}>
                    <EditQuotation />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.viewPendingQuotationItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewPendingQuotationItem}>
                    <ViewPendingQuotationItem />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editQuotationItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editQuotationItem}>
                    <EditQuotationItem />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.order)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.order}>
                    <Order excel={true} />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.orderDetails)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.orderDetails}>
                    <OrderDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createOrder)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createOrder}>
                    <CreateOrder />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.orderLineItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.orderLineItem}>
                    <OrderLineItemList excel={true} />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.orderLineItemDetails)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.orderLineItemDetails}>
                    <OrderLineItemDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.orderDispatchDetails)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.orderDispatchDetails}>
                    <OrderDispatchDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.orderDispatch)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.orderDispatch}>
                    <OrderDispatchList excel={true} />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.softscheduling)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.softscheduling}>
                    <SoftScheduling excel={true} />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.sampleInformation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.sampleInformation}>
                    <SampleInformation excel={true} />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewsoftscheduling)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewsoftscheduling}>
                    <SoftSchedulingDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.users)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.users}>
                    <Users />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.powerBiAdmin)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.powerBiAdmin}>
                    <PowerBIAdmin />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewPowerBiReport)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewPowerBiReport}>
                    <ViewPowerBiReport />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createPowerBiReport)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createPowerBiReport}>
                    <CreateEditPowerBiReport />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editPowerBiReport)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editPowerBiReport}>
                    <CreateEditPowerBiReport />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.showPowerBiReport)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.showPowerBiReport}>
                    <ShowPowerBiReport />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createUser)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createUser}>
                    <CreateUser />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewUser)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewUser}>
                    <UserDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editUser)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editUser}>
                    <EditUser />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.purchaseOrders)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.purchaseOrders}>
                    <PurchaseOrders />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createPurchaseOrder)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createPurchaseOrder}>
                    <CreatePurchaseOrder />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewPurchaseOrder)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewPurchaseOrder}>
                    <PurchaseOrderDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editPurchaseOrder)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editPurchaseOrder}>
                    <EditPurchaseOrder />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewDispatch)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewDispatch}>
                    <ViewDispatch />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.debitNoteGC)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.debitNoteGC}>
                    <DebitNoteGC />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createDebitNoteGC)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createDebitNoteGC}>
                    <CreateEditDebitNoteGC />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editDebitNoteGC)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editDebitNoteGC}>
                    <CreateEditDebitNoteGC />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewDebitNoteGC)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewDebitNoteGC}>
                    <DebitNoteView />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createsettings)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createsettings}>
                    <CreateSettings />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editsettings)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editsettings}>
                    <EditSettings />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewsettings)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewsettings}>
                    <ViewSettings />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.settings)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.settings}>
                    <Settings />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.mrin)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.mrin}>
                    <MRIN />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editMRIN)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editMRIN}>
                    <MRINCreateEdit />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewMRIN)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewMRIN}>
                    <MRINDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createMRIN)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createMRIN}>
                    <MRINCreateEdit />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.gc)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.gc}>
                    <GC />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createGC)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createGC}>
                    <CreateGC />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editGC)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editGC}>
                    <EditGC />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewGC)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewGC}>
                    <GcDetails />
                  </AuthWrapperWithTab>
                }
              />

              {/* <Route path={routes.DispatchNew} exact element={
                <AuthWrapperWithTab path={routes.DispatchNew}>
                  <DispatchNew />
                </AuthWrapperWithTab>} /> */}
              <Route
                path={checkRouteRedirection(routes.CreateDispatchNew)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.CreateDispatchNew}>
                    <VendorPurchaseForm />
                  </AuthWrapperWithTab>
                }
              />
              {/* <Route
                path={checkRouteRedirection(routes.EditDispatchNew)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.EditDispatchNew}>
                    <EditDispatchNew />
                  </AuthWrapperWithTab>
                }
              /> */}
              <Route
                path={checkRouteRedirection(routes.ViewDispatchNew)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.ViewDispatchNew}>
                    <ViewDispatchNew />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.gcrequired)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.gcrequired}>
                    <GcRequired />
                  </AuthWrapperWithTab>
                }
              />
              {/* gcdailyrates */}
              <Route
                path={checkRouteRedirection(routes.gcdailyrates)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.gcdailyrates}>
                    <Gcdailyrates />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.creategcdailyrates)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.creategcdailyrates}>
                    <CreateGcdailyrates />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editgcdailyrates)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editgcdailyrates}>
                    <EditGcdailyrates />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewgcdailyrates)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewgcdailyrates}>
                    <ViewGcdailyrates />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.gcenquiry)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.gcenquiry}>
                    <Gcenquiry />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.creategcenquiry)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.creategcenquiry}>
                    <CreateGcenquiry />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editgcenquiry)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editgcenquiry}>
                    <EditGcenquiry />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewgcenquiry)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewgcenquiry}>
                    <ViewGcenquiry />
                  </AuthWrapperWithTab>
                }
              />
              {/* end gcdailyrates */}
              <Route
                path={checkRouteRedirection(routes.allocation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.allocation}>
                    <Allocation />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editallocation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editallocation}>
                    <EditAllocation />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.viewallocation)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewallocation}>
                    <AllocationDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.packingType)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.packingType}>
                    <PackingType />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.blendSheet)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.blendSheet}>
                    <BlendSheet />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createBlendSheet)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createBlendSheet}>
                    <BlendSheetCreateEdit />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewBlendSheet)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewBlendSheet}>
                    <ViewBlendSheet />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editBlendSheet)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editBlendSheet}>
                    <BlendSheetCreateEdit />
                  </AuthWrapperWithTab>
                }
              />

              <Route
                path={checkRouteRedirection(routes.createpackingType)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createpackingType}>
                    <CreatePackingType />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editpackingType)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editpackingType}>
                    <EditPackingType />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewpackingType)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewpackingType}>
                    <PackingTypeDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.supplier)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.supplier}>
                    <Supplier />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createSupplier)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createSupplier}>
                    <CreateSupplier />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editSupplier)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editSupplier}>
                    <EditSupplier />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewSupplier)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewSupplier}>
                    <SupplierDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.masterSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.masterSample}>
                    <MasterSamples />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewMasterSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewMasterSample}>
                    <ViewMasterSample />
                  </AuthWrapperWithTab>
                }
              />
              {/* <Route
                path={checkRouteRedirection(routes.editMasterSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editMasterSample}>
                    <EditMasterSample />
                  </AuthWrapperWithTab>
                }
              /> */}

            <Route
              path={checkRouteRedirection(routes.createMasterSample)}
              exact
              element={
                <AuthWrapperWithTab path={routes.createMasterSample}>
                  <CreateEditMasterSample />
                </AuthWrapperWithTab>
              }
            />
            <Route
              path={checkRouteRedirection(routes.editMasterSample)}
              exact
              element={
                <AuthWrapperWithTab path={routes.editMasterSample}>
                  <CreateEditMasterSample />
                </AuthWrapperWithTab>
              }
            />

              {/* CreateEditMasterSample */}
              {/* <Route
                path={checkRouteRedirection(routes.createMasterSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createMasterSample}>
                    <CreateMasterSample />
                  </AuthWrapperWithTab>
                }
              /> */}
              {/* <Route
                path={checkRouteRedirection(routes.editMasterSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editMasterSample}>
                    <EditMasterSample />
                  </AuthWrapperWithTab>
                }
              /> */}
              {/* alternative sample */}
              <Route
                path={checkRouteRedirection(routes.alternativeSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.alternativeSample}>
                    <AlternativeSamples />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewAlternativeSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewAlternativeSample}>
                    <ViewAlternativeSample />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createAlternativeSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createAlternativeSample}>
                    <CreateEditAlternativeSample />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editAlternativeSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editAlternativeSample}>
                    <CreateEditAlternativeSample />
                  </AuthWrapperWithTab>
                }
              />
              {/* customer sample */}
              <Route
                path={checkRouteRedirection(routes.customerSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.customerSample}>
                    <CustomerSamples />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewCustomerSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewCustomerSample}>
                    <ViewCustomerSample />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createCustomerSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createCustomerSample}>
                    <CreateEditCustomerSample />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editCustomerSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editCustomerSample}>
                    <CreateEditCustomerSample />
                  </AuthWrapperWithTab>
                }
              />
              {/* <Route path={routes.viewMiv} exact element={
                <AuthWrapperWithTab path={routes.viewMiv}>
                  <MivDetails />
                </AuthWrapperWithTab>} />
                <Route path={routes.editMiv} exact element={
                <AuthWrapperWithTab path={routes.editMiv}>
                  <MivDetails edit={true} />
                </AuthWrapperWithTab>} /> */}
              <Route
                path={checkRouteRedirection(routes.forecastCapacity)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.forecastCapacity}>
                    <ForecastCapacity />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createForecastCapacity)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createForecastCapacity}>
                    <CreateEditForecastCapacity />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editForecastCapacity)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editForecastCapacity}>
                    <CreateEditForecastCapacity />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewForecastCapacity)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewForecastCapacity}>
                    <ForecastCapacityView />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.batchoutput)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.batchoutput}>
                    <BatchOutputs />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.batchOutputDetails)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.batchOutputDetails}>
                    <BatchOutputsDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createBatchOutput)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createBatchOutput}>
                    <CreateBatchOutput />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editBatchOutput)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editBatchOutput}>
                    <EditBatchOutput />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.FGvalidity)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.FGvalidity}>
                    <FGvalidity />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createFGvalidity)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createFGvalidity}>
                    <CreateEditFGvalidity />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editFGvalidity)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editFGvalidity}>
                    <CreateEditFGvalidity />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.FGvalidityDetails)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.FGvalidityDetails}>
                    <FGvalidityDetails />
                  </AuthWrapperWithTab>
                }
              />
              {/* production schedule */}
              <Route
                path={checkRouteRedirection(routes.productionSchedule)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.productionSchedule}>
                    <ProductionSchedule />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createProductionSchedule)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createProductionSchedule}>
                    <CreateEditProductionSchedule />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editProductionSchedule)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editProductionSchedule}>
                    <CreateEditProductionSchedule />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewProductionSchedule)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewProductionSchedule}>
                    <ProductionScheduleDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.calendarBlockingProductionSchedule)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.calendarBlockingProductionSchedule}>
                    <ProductionScheduleCalendarBlocking />
                  </AuthWrapperWithTab>
                }
              />
              {/* pre shipment sample */}
              <Route
                path={checkRouteRedirection(routes.preShipmentSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.preShipmentSample}>
                    <PreShipmentSample />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.createPreShipmentSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.createPreShipmentSample}>
                    <CreateEditPreShipmentSample />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editPreShipmentSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editPreShipmentSample}>
                    <CreateEditPreShipmentSample />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewPreShipmentSample)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewPreShipmentSample}>
                    <PreShipmentSampleDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.viewPreShipmentSampleLineItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.viewPreShipmentSampleLineItem}>
                    <PreShipmentSampleDetails />
                  </AuthWrapperWithTab>
                }
              />
              <Route
                path={checkRouteRedirection(routes.editPreShipmentSampleLineItem)}
                exact
                element={
                  <AuthWrapperWithTab path={routes.editPreShipmentSampleLineItem}>
                    <EditPreShipmentLineItem />
                  </AuthWrapperWithTab>
                }
              /> 
            {/* Finance Routes start */}
            <Route
              path={checkRouteRedirection(routes.finance)}
              exact
              element={
                <AuthWrapperWithTab path={routes.finance}>
                  <Finance />
                </AuthWrapperWithTab>
              }
            />
            <Route
              path={checkRouteRedirection(routes.createFinanceCosting)}
              exact
              element={
                <AuthWrapperWithTab path={routes.createFinanceCosting}>
                  <CreateEditFinanceCosting />
                </AuthWrapperWithTab>
              }
            />
            <Route
              path={checkRouteRedirection(routes.editFinanceCosting)}
              exact
              element={
                <AuthWrapperWithTab path={routes.editFinanceCosting}>
                  <CreateEditFinanceCosting />
                </AuthWrapperWithTab>
              }
            />
            <Route
              path={checkRouteRedirection(routes.viewFinanceCosting)}
              exact
              element={
                <AuthWrapperWithTab path={routes.viewFinanceCosting}>
                  <FinanceCostingDetails />
                </AuthWrapperWithTab>
              }
            />
            {/* Finance Routes End */}           
              <Route
                path={routes.login}
                element={
                  <CheckAuth>
                    <Login />
                  </CheckAuth>
                }
              />
              <Route
                path={routes.forget}
                element={<ForgetPassword />}
              />
              <Route
                path={routes.authenticator}
                element={
                  <CheckAuthenticator>
                    <Authenticator />
                  </CheckAuthenticator>
                }
              />
              {/* <Route path="/profile" element={<UserProfile />} /> */}
              <Route
                path={routes.vendorLogin}
                element={
                  <CheckAuth>
                    <WithBackground>
                      <VendorLogin />
                    </WithBackground>
                  </CheckAuth>
                }
              />
              <Route path="*" element={<Navigate to="/home" />} />
            </Routes>
          </BreadcrumbTrailProvider>
          </AutoLogoutProvider>
        
      </AuthContext.Provider>
    </>
  );
}

export default App;